import { render, staticRenderFns } from "./TarBarItem.vue?vue&type=template&id=eab783fc&scoped=true&"
import script from "./TarBarItem.vue?vue&type=script&lang=js&"
export * from "./TarBarItem.vue?vue&type=script&lang=js&"
import style0 from "./TarBarItem.vue?vue&type=style&index=0&id=eab783fc&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eab783fc",
  null
  
)

export default component.exports